module.exports = {
  available: false,
    customSplashBanner: "SOLD OUT!",
  customSplashBannerColor: "#99c266",
  slug: "maui2019",
  name: "Maui",
  year: "2019",
  region: "Hawaii",
  country: "United States",
  location: "Maui, Hawaii",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: true,
  useHawaiiPricing: false,
  useHawaiiPhoneGate: false,
  soldOutPercent: 0,
  soldOutPercentHawaii: 100,
  soldOutReferralTrip: 'kauai2021',
  soldOutReferralText: 'Kauai Just Added',
  banners: [''],
  saleEndsAt: '',
  thinBar1: '',
  thinBar2: '',
  onLocationPricingAvailable: false,
  onLocationPricingCutoff: "2019-08-21T01:00:00",
  onLocationMessage: "",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: false,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: false,
  dates: "Sept 21-27, 2019",
  timeZone: "HST",
  startTime: "7:30 PM (HST)",
  checkInDay: "Saturday",
  checkInDate: "September 21, 2019",
  checkInTime: "4:00 PM (HST)",
  arrivePriorTo: "4:30 PM (HST)",
  checkOutDay: "Friday",
  checkOutDate: "September 27, 2019",
  checkOutTime: "12:00 PM (HST)",
  disableMonthlyPaymentOption: true,
  maxSubMonths: 10,
  useMaxSubMonthsCutoff: "12-15-2018",
  availabilityCutoff: "09-20-2019",
  departureAirport: "Kahului",
  departureAirCode: "OGG",
  venue: "The Ritz-Carlton, Kapalua",
  venueSlug: "ritz-kapalua",
  homeVideoId: 235191721,
  requestBrochureCategoryID: "ecf0a94cad",
  finalDetailsFormHash: "zbv7rv61grnl05",
  finalDetailsFormEnabled: true,
  mapUrl: "https://www.google.com/maps?q=The+Ritz-Carlton,+Kapalua&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjckOG4uObaAhVP8mMKHT-uAawQ_AUICigB",
  perks: [
    "7 Days / 6 Nights The Ritz-Carlton, Kapalua Accommodations",
    "$35 Daily Resort Fee (High Speed Internet, Kapalua Resort Shuttle Services for travel within Kapalua Resort, Discounted Golf Fees & Preferred Tee Times, Cultural History Tours and Resort Activities, such as Basketball, Tennis, Shuffleboard, Croquet & more!) ",
    "Porterage Fees (Baggage Handling)",
    "Everlasting Tours On-Location Staff",
    "Entertainment Wristbands ($500 value per person, included!)"
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists"
  ],
  lineup: [
    {
      key: "mercyme",
      kind: "artist",
      name: "MercyMe",
      nameFirst: "MercyMe",
      nameLast: ""
    }, {
      key: "drgarychapman",
      kind: "speaker",
      name: "Dr. Gary Chapman",
      nameFirst: "Dr. Gary",
      nameLast: "Chapman",
      book: "5-love-languages"
    }, {
      key: "kimwalkersmith",
      kind: "artist",
      name: "Kim Walker Smith",
      nameFirst: "Kim",
      nameLast: "Walker Smith"
    }, {  
      key: "timtimmons",
      kind: "artist",
      name: "Tim Timmons",
      nameFirst: "Tim",
      nameLast: "Timmons"
    }, {   
      key: "troytyler",
      kind: "speaker",
      name: "Troy Tyler",
      nameFirst: "Troy",
      nameLast: "Tyler"
    }
  ],
  itinerary: [
    {
      name: "Sat",
      body: "\
        <p>\
          <strong>Day 1 | Sept 21</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & Love Song Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>\
            Free Night: Relax & Unwind\
          </strong>\
        </p>\
      "
    }, {
      name: "Sun",
      body: "\
        <p>\
          <strong>Day 2 | Sept 22</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship with Tim Timmons<br />\
           Grand Opening with Troy Tyler<br />\
            Dr. Gary Chapman Session 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Date Night in Paradise*</strong>\
        </p>\
      "
    }, {
      name: "Mon",
      body: "\
        <p>\
          <strong>Day 3 | Sept 23</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            <strong>Worship with MercyMe<br />\
            Dr. Gary Chapman Session 3 & 4</strong>\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Starry Nights Social*</strong>\
        </p>\
      "
    }, {
      name: "Tue",
      body: "\
        <p>\
          <strong>Day 4 | Sept 24</strong>\
        </p>\
        <p>\
          Morning &amp; Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Tim Timmons Performance</strong><br />\
          <strong>Kim Walker Smith Performance</strong>\
        </p>\
      "
    }, {
      name: "Wed",
      body: "\
        <p>\
          <strong>Day 5 | Sept 25</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – Love Song Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>\
      "
    }, {
      name: "Thu",
      body: "\
        <p>\
          <strong>Day 6 | Sept 26</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Worship with Tim Timmons</strong><br />\
          <strong>MercyMe Performance</strong>\
        </p>\
      "
    }, {
      name: "Fri",
      body: "\
        <p>\
          <strong>Day 7 | Sept 27</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>\
      "
    }
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [
  ],
  rooms: {
    "terrace": {
      key: "terrace",
      name: "Terrace Room",
      kind: "room",
      trip: "maui2019",
      upsell: false,
      prices: {
        default: 5798,
        hawaii: 3798,
        onlocation: 3998,
      },
      extraNightPrices: {
        default: 475,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-terrace.jpg",
      header: "/images/rooms/maui-terrace.jpg",
      description: "Spacious 440 sqft. guest room, Queen/Queen or one King (bedding type not guaranteed), spacious outdoor lanai balcony (limited view), luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
      "deluxe": {
      key: "deluxe",
      name: "Deluxe Room",
      kind: "room",
      trip: "maui2019",
      upsell: "res-garden-suite",
      prices: {
        default: 5998,
        hawaii: 3998,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-deluxe.jpg",
      header: "/images/rooms/maui-deluxe-header.jpg",
      description: "Spacious 440 sqft. guest room, Queen/Queen or one King (bedding type not guaranteed), spacious outdoor lanai balcony overlooking tropical landscape or pool, luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "deluxe-king": {
      key: "deluxe-king",
      name: "Deluxe Room - King Guaranteed",
      kind: "room",
      trip: "maui2019",
      upsell: "res-garden-suite",
      prices: {
        default: 6198,
        hawaii: 4198,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 575,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-deluxe-king.jpg",
      header: "/images/rooms/maui-deluxe-king.jpg",
      description: "Spacious 440 sqft. guest room, one King (bedding guaranteed), spacious outdoor lanai balcony overlooking tropical landscape or pool, a luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "garden-suite": {
      key: "garden-suite",
      name: "Garden Suite",
      kind: "hybrid",
      trip: "maui2019",
      upsell: "res-garden-suite",
      prices: {
        default: 8798,
        hawaii: 5398,
        onlocation: 5198,
      },
      extraNightPrices: {
        default: 750,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-garden.jpg",
      header: "/images/rooms/maui-garden.jpg",
      description: "Elegantly appointed 900 sqft. suite, two spacious outdoor lanai balconies with beautiful resort, mountain, and/or golf course views, a separate living room, floor to ceiling windows to maximize the views, a luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "res-garden-suite": {
      key: "res-garden-suite",
      name: "Residential Garden View Suite",
      kind: "hybrid",
      trip: "maui2019",
      upsell: "res-ocean-view-suite",
      prices: {
        default: 8998,
        hawaii: 5598,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 850,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "SOLD OUT",
      image: "/images/rooms/maui-res-garden-suite.jpg",
      header: "/images/rooms/maui-res-garden-suite.jpg",
      description: "This spacious 900 sq ft suite offers two wide outdoor lanai balconies, partial kitchen with top-of-the-line appliances, separate living room, large deep soaking tub, Hawaiian-inspired artwork in furnishing and suite decorations, and elegant dark wood floors throughout."
    },
    "deluxe-ocean": {
      key: "deluxe-ocean",
      name: "Deluxe Ocean View",
      kind: "room",
      trip: "maui2019",
      upsell: "res-ocean-view-suite",
      prices: {
        default: 6798,
        hawaii: 4398,
        onlocation: 5598,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-deluxe-ocean.jpg",
      header: "/images/rooms/maui-deluxe-ocean.jpg",
      description: "Spacious 440 sqft. guest room, Queen/Queen or one King (bedding type not guaranteed), spacious outdoor lanai balcony with partial ocean views, luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "deluxe-ocean-king": {
      key: "deluxe-ocean-king",
      name: "Deluxe Ocean View - King Guaranteed",
      kind: "room",
      trip: "maui2019",
      upsell: "res-ocean-view-suite",
      prices: {
        default: 7198,
        hawaii: 4598,
        onlocation: 6198,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "SOLD OUT",
      image: "/images/rooms/maui-deluxe-ocean.jpg",
      header: "/images/rooms/maui-deluxe-ocean.jpg",
      description: "Spacious 440 sqft. guest room, one King (bedding guaranteed), spacious outdoor lanai balcony with partial ocean views, luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "hybrid",
      trip: "maui2019",
      upsell: "res-ocean-view-suite",
      prices: {
        default: 9598,
        hawaii: 7598,
        onlocation: 8398,
      },
      extraNightPrices: {
        default: 950,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-ocean-view-suite.jpg",
      header: "/images/rooms/maui-ocean-view-suite.jpg",
      description: "Elegantly appointed 900 sqft. suite, two spacious outdoor lanai balconies with picturesque ocean views, a separate living room, floor to ceiling windows to maximize the views, a luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more."
    },
    "res-ocean-view-suite": {
      key: "res-ocean-view-suite",
      name: "Residential Ocean View Suite",
      kind: "hybrid",
      trip: "maui2019",
      upsell: false,
      prices: {
        default: 9998,
        hawaii: 7998,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 1150,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: true,
      recommended: false,
      note: "SOLD OUT",
      image: "/images/rooms/maui-res-ocean-suite.jpg",
      header: "/images/rooms/maui-res-ocean-suite.jpg",
      description: "This spacious 900 sq ft suite offers partial ocean views of the Pacific Ocean from the two wide outdoor lanai balconies, partial kitchen with top-of-the-line appliances, separate living room, large deep soaking tub, Hawaiian-inspired artwork in furnishing and suite decorations, and elegant dark wood floors throughout."
    },
    "oceanfront-suite": {
      key: "oceanfront-suite",
      name: "Ocean Front Suite",
      kind: "suite",
      trip: "maui2019",
      upsell: "",
      prices: {
        default: 14998,
        hawaii: 10598,
        onlocation: 14598,
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: true,
      note: "SOLD OUT",
      image: "/images/rooms/maui-oceanfront.jpg",
      header: "/images/rooms/maui-oceanfront.jpg",
      description: "Elegantly appointed 1200 sqft. suite, two spacious outdoor lanai balconies with stunning oceanfront views, a separate living room, floor to ceiling windows to maximize the views, a luxurious marble bathroom with a dual vanity, Nespresso coffee maker, oversized soaking tub, and more!"
    }
  }
}



// WEBPACK FOOTER //
// ./lib/trips/maui2019.js